import React, { Fragment, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import { store } from './AddOrEdit';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  customerForm: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gridGap: theme.spacing(1),
    gridAutoFlow:'row'
  },
  mobile: {
    '& input': {
      direction: 'rtl',
    },
  },
}));

const Form = () => {
  const classes = useStyles();
  const { state, dispatch, validation } = useContext(store);
  const { values, error } = state;

  const handleChangeTF = (e) => {
    let { name, value } = e.target;
    dispatch({ type: 'CHANGE_FIELD', payload: { [name]: value } });
  };

  return (
    <Fragment>
      <div className={classes.customerForm}>
        <TextField
          name="firstName"
          label={values?.legal ? 'نام مدیرعامل یا نماینده شرکت' : 'نام'}
          value={values?.firstName || ''}
          onChange={handleChangeTF}
          onBlur={validation}
          error={!!error.firstName || false}
          helperText={error.firstName || null}
          fullWidth
          variant="outlined"
          size="medium"
        />
        <TextField
          name="lastName"
          label={
            values?.legal
              ? 'نام خانوادگی مدیرعامل یا نماینده شرکت'
              : 'نام خانوادگی'
          }
          value={values?.lastName || ''}
          onChange={handleChangeTF}
          onBlur={validation}
          error={!!error.lastName || false}
          helperText={error.lastName || null}
          fullWidth
          variant="outlined"
          size="medium"
        />

        <TextField
          name="nationalCode"
          label={values?.legal ? 'کدملی مدیرعامل یا نماینده شرکت' : 'کدملی'}
          value={values?.nationalCode || ''}
          onChange={handleChangeTF}
          fullWidth
          variant="outlined"
          type="number"
          size="medium"
        />
        <TextField
          name="mobilePhone"
          label={
            values?.legal
              ? 'شماره‌موبایل مدیرعامل یا نماینده شرکت'
              : 'شماره موبایل'
          }
          value={values?.mobilePhone || ''}
          onChange={handleChangeTF}
          onBlur={validation}
          error={!!error.mobilePhone || false}
          helperText={error.mobilePhone || null}
          fullWidth
          variant="outlined"
          size="medium"
          className={classes.mobile}
        />
        <TextField
          name="username"
          label="نام کاربری"
          value={values?.username || ''}
          onChange={handleChangeTF}
          onBlur={validation}
          error={!!error.username || false}
          helperText={error.username || null}
          fullWidth
          variant="outlined"
          size="medium"
        />
        <TextField
          name="password"
          label="گذرواژه"
          value={values?.password || ''}
          onChange={handleChangeTF}
          onBlur={validation}
          error={!!error.password || false}
          helperText={error.password || null}
          fullWidth
          variant="outlined"
          size="medium"
          type="password"
        />
        <TextField
          name="commissionShare"
          label="درصد سهم کاربر از کارمزد کمیسیون شرکت"
          value={
            values?.commissionShare === 0
              ? 0
              : values?.commissionShare
              ? values.commissionShare
              : ''
          }
          onChange={handleChangeTF}
          fullWidth
          variant="outlined"
          size="medium"
        />
        <TextField
          name="voipExt"
          label="شماره داخلی VOIP"
          type="number"
          value={
            values?.voipExt?values.voipExt: ''
          }
          onChange={handleChangeTF}
          fullWidth
          variant="outlined"
          size="medium"
        />
        <TextField
          name="voipExt2"
          label="شماره داخلی VOIP دوم"
          type="number"
          value={
            values?.voipExt2?values.voipExt2: ''
          }
          onChange={handleChangeTF}
          fullWidth
          variant="outlined"
          size="medium"
        />
      </div>
    </Fragment>
  );
};

export default Form;
